var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('x-default-data-table',{attrs:{"x-options":_vm.tableOptions,"x-context":_vm.self},scopedSlots:_vm._u([{key:"item.details",fn:function(ref){
var item = ref.item;
return [_c('json-viewer',{attrs:{"value":(item.details && item.details.length === 1 && item.details[0]) || item.details,"copyable":""}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }